import React from 'react';
import PropTypes from 'prop-types';
import styles from './Tooltip.module.css';
import classNames from 'classnames';

const Tooltip = ({ children, text, position = 'top', className, isWhiteBg }) => {
  return (
    <div
      className={classNames(
        className,
        styles.tooltipWrapper,
        styles.tooltipWrapper,
        isWhiteBg ? styles.whiteBg : null,
        className
      )}
    >
      {children}
      <div className={`${styles.tooltip} ${styles[position]}`}>{text}</div>
    </div>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  className: PropTypes.string,
};

export default Tooltip;
